import React, {
  createContext,
  useContext,
  useEffect,
  useRef,
  useState,
} from 'react';
import { useLocation } from 'react-router-dom';
import { SelfUserClassificationEnum } from '../../../shared/constants/constants';
import { getSessionData } from '../../../utils/interceptors/localStorageService';


const RouteHistoryContext = createContext([]);

export const RouteHistoryProvider = ({ children }) => {
  const location = useLocation();
  const [history, setHistory] = useState([]);
  const historyRef = useRef([]);
  const [userId, setUserId] = useState(null);

  useEffect(() => {
    console.log("history?? ", history)
  }
    , [history])

  // Load user and history on mount
  useEffect(() => {
    const session = getSessionData();

    if (
      session?.userClassification ===
      SelfUserClassificationEnum.BACKOFFICE_ADMINISTRATORS.value
    ) {
      const uid = session?.id || session?.userId;
      setUserId(uid);

      const saved = localStorage.getItem(`routeHistory:${uid}`);
      const parsed = saved ? JSON.parse(saved) : [];
      setHistory(parsed);
      historyRef.current = parsed;
    }
  }, []);

  // Update on route change
  useEffect(() => {
    const path = location.pathname;

    const excludedRoutes = [
      '/',
      '/otp',
      '/forgot-password',
      '/validate-user',
      '/validate-user/security-features',
      '/login',
      '/admin/login',
      '/signup',
      '/authentication',
    ];

    const isExcluded = excludedRoutes.some(
      (route) => path === route || path.startsWith(`${route}/`)
    );

    if (!userId || isExcluded) return;

    const updated = historyRef.current.filter((p) => p !== path);
    updated.unshift(path);
    const newHistory = updated.slice(0, 10);

    historyRef.current = newHistory;
    setHistory(newHistory);
    localStorage.setItem(`routeHistory:${userId}`, JSON.stringify(newHistory));
  }, [location.pathname, userId]);

  return (
    <RouteHistoryContext.Provider value={history}>
      {children}
    </RouteHistoryContext.Provider>
  );
};

export const useRouteHistory = () => useContext(RouteHistoryContext);
